import { render, staticRenderFns } from "./SignUpLayout.vue?vue&type=template&id=4df96e8f&scoped=true"
import script from "./SignUpLayout.vue?vue&type=script&lang=js"
export * from "./SignUpLayout.vue?vue&type=script&lang=js"
import style0 from "./SignUpLayout.vue?vue&type=style&index=0&id=4df96e8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df96e8f",
  null
  
)

export default component.exports